import React, { useState, useEffect } from 'react';
import { Stethoscope, Calendar, BarChart3, Receipt, Users, MapPin } from 'lucide-react';
import { API_BASE_URL } from '../../config';

export default function FeaturesSection() {

  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);

  const iconMap = {
    'Stethoscope': Stethoscope,
    'Calendar': Calendar,
    'Receipt': Receipt,
    'Users': Users,
    'BarChart3': BarChart3,
    'MapPin': MapPin
  };

  const fetchFeatures = async () => {
    try {
      setLoading(true);

      const response = await fetch(`${API_BASE_URL}/admin/feature`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      });

      const result = await response.json();

      if (result.success) {
        setFeatures(result.data);
      }
    } catch (error) {
      console.error('Failed to load features:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFeatures();
  }, []);

  if (loading) {
    return (
      <section className="py-16 md:py-24 bg-gray-50">
        <div className="px-4 mx-auto text-center max-w-7xl sm:px-6 lg:px-8">
          <p>Loading features...</p>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 md:text-4xl">
            A Feature for Every Need
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Everything your medical representatives and managers need to succeed.
          </p>
        </div>
        <div className="grid gap-8 mt-12 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div key={feature.title} className="p-6 transition-shadow bg-white shadow-md rounded-xl hover:shadow-xl">
                <div className="flex items-center justify-center w-12 h-12 text-white bg-blue-600 rounded-md">
                  {IconComponent && <IconComponent className="w-6 h-6" aria-hidden="true" />}
                </div>
                <div className="mt-5">
                  <h3 className="text-lg font-medium text-gray-900">{feature.title}</h3>
                  <p className="mt-2 text-base text-gray-600">
                    {feature.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
